<template>
  <div class="tariff_packet_items">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <span class="select">
        <WrapDatePicker
            type="month"
            value_type="YYYY-MM"
            v-model="filter.date"
            :range="false"
            :placeholder="translate('traffic_packet_list.mno_packet_item.date')"
            :label="translate('traffic_packet_list.mno_packet_item.date')"
            :clearable="true"
            :confirm="false"
        />
      </span>

      <div class="select">
        <label> {{ translate('traffic_packet_list.mno_packet_item.client') }} </label>
        <tree-select
            :options="client_list"
            :multiple="false"
            v-model="filter.client_id"
            :placeholder="translate('traffic_packet_list.mno_packet_item.client')"
            :clearable="true"
            :searchable="true"
        />
      </div>

      <div class="select">
        <fg-input
            type="text"
            v-model="filter.fid"
            :placeholder="translate('traffic_packet_list.mno_packet_item.fid')"
            :label="translate('traffic_packet_list.mno_packet_item.fid')"
            :clearable="true"
        />
      </div>

      <div class="select">
        <label> {{ translate('traffic_packet_list.tariff_packet_item.type') }} </label>
        <tree-select
            :options="type_list"
            :multiple="false"
            v-model="filter.type"
            :placeholder="translate('traffic_packet_list.tariff_packet_item.type')"
            :clearable="true"
        />
      </div>

      <div class="select">
        <label> {{ translate('traffic_packet_list.tariff_packet_item.status') }} </label>
        <tree-select
            :options="status_list"
            :multiple="false"
            v-model="filter.status"
            :placeholder="translate('traffic_packet_list.tariff_packet_item.status')"
            :clearable="true"
        />
      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="Object.keys(summary).length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("traffic_packet_list.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col" style="width: 60px">
            {{ translate('traffic_packet_list.tariff_packet_item.date') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.device_fid') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.client_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.packet_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.traffic_status') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.type') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.region') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.cost') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.ts_create') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariff_packet_item.ts_update') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, key) in items"
            :key="key" class="packet_item"
            :class="{ active_item: item.status > 0, over_item: item.is_over }"
            @click="show_info(item.id)"
        >
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.date')" style="width: 60px">
            {{ item.date }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.device_fid')" class="device_name" @click.stop="">
            <router-link :to="{ path: '/device/' + item.device_fid + '/tariffication' }">
              {{ item.device_fid }}
            </router-link>
            <p>{{ item.device_name }}</p>
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.client_name')">
            {{ item.client_name }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.name')">
            {{ item.name }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.packet_name')">
            {{ item.packet_name }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.traffic_status')">
            {{ item.traffic_status }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.type')">
            {{ item.type }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.region')">
            {{ item.region }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.cost')">
            {{ item.cost }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.ts_create')">
            {{ get_date(item.ts_create) }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariff_packet_item.ts_update')">
            {{ get_date(item.ts_update) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

import TariffPacketItem from "./DevicePacketItemsModal/Index.vue";
import WrapDatePicker from "@/components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'TariffPacketItems',
  components: {
    WrapDatePicker,
    TariffPacketItem
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data() {
    return {
      load: true,
      items: {},
      filter: {
        date: null,
        fid: "",
        status: null,
        type: null,
        client_id: null
      },
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
  computed: {
    client_list() {
      return this.$store.getters.getClientsList.map((client) => {
        return {id: client.id, label: client.name}
      })
    },
    type_list() {
      return [
        {id: 1, label: "Main"},
        {id: 2, label: "Additonal"}
      ];
    },
    status_list() {
      return [
        {id: 1, label: "Active"},
        {id: 0, label: "Incactive"},
        {id: "suspended", label: "Suspended"}
      ];
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        let string = '?'
        for (let key in this.filter) {
          if (this.filter[key]) {
            string += '&' + key + '=' + this.filter[key]
          }
        }
        history.pushState(null, null, this.$route.path + string)

        this.change_input()
      }
    },
  },

  created() {
    this.check_query()
  },

  activated() {
    this.check_query()
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_tariff_packet_items, 100)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'date':
            case 'fid':
            case 'status':
            case 'type':
            case 'client_id':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }

      this.get_tariff_packet_items()
    },
    get_tariff_packet_items() {
      let params = {}
      Object.keys(this.filter).forEach((key) => {
        if(this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== ""){
          params[key] = this.filter[key]
        }
      })

      if (params.status === "suspended") {
        delete (params.status)
        params.suspense = 1
      }

      this.$http.v1.getTariffPacketItems(params, (response) => {
        this.items = response.data.data
        this.summary = response.data.summary
      })
    },
    show_info(tariff_packet_item_id) {
      if (!tariff_packet_item_id) return
      let t = this.$createElement(TariffPacketItem, {
        props: {
          tariff_packet_item_id
        },
        on: {
          close: () => {
            this.$modal.hide('tariff_packet_item')
            this.check_link = true
          },
          update: () => {
            this.$emit("update", this.send_filter)
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800, //TODO in const to
        adaptive: true,
        clickToClose: true,
        name: 'tariff_packet_item'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },
}
</script>
<style lang='scss' scoped>
.tariff_packet_items {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 30px;

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex: 1;

    .select {
      width: 30%;
    }

    .checkboxs {
      width: 30%;
      display: flex;
      align-content: center;
      justify-content: space-between;

      .checkbox {
        width: 30%;
        margin: 0;
        min-width: auto;
      }
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    & > * {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .response_table{
    flex: 10;
    padding: 10px 0 0;
    .summary{
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px;
      margin-bottom: 10px;
      p{
        font-size: 12px;
        line-height: 100%;
        margin-bottom: 0;
      }
      span{
        margin-right: 5px;
        &:last-child{
          margin-right: 0;
        }
        br{
          display: none;
        }
      }
    }
    table{
      height: calc(100% - 55px);
      .device_name{
        p,a{
          font-size: 10px;
          margin-bottom: 0;
        }
      }
    }
  }
}

.active_item {
  background-color: #41b88330;
}

.over_item {
  background-color: #ebcb6230;
}
</style>
